// extracted by mini-css-extract-plugin
export var box = "PricingBox-module--box--734e9";
export var item = "PricingBox-module--item--4264b";